/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Карта «UPPER_CASE-ключ → значение». Состав не фиксирован: новые ключи группы server_options появляются здесь автоматически, тип каждого значения задаётся его настройкой в БД.
 * @export
 * @interface GetServerOptions200ResponseDataValues
 */
export interface GetServerOptions200ResponseDataValues {
  /**
   * Минимальная допустимая длина пароля
   * @type {number}
   * @memberof GetServerOptions200ResponseDataValues
   */
  PASSWORD_MIN_LENGTH?: number
  /**
   * Максимальный размер загружаемого изображения товарного знака в байтах
   * @type {number}
   * @memberof GetServerOptions200ResponseDataValues
   */
  TRADE_MARK_IMAGE_MAX_SIZE?: number
  /**
   * MIME-типы изображений, доступных для загрузки в качестве изображения товарного знака (через запятую)
   * @type {string}
   * @memberof GetServerOptions200ResponseDataValues
   */
  TRADE_MARK_IMAGE_MIME_TYPES?: string
  /**
   * Минимальная длина комментария при обращении в техническую поддержку
   * @type {number}
   * @memberof GetServerOptions200ResponseDataValues
   */
  CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH?: number
  /**
   * Минимальная длина строки для получения подсказок поиска (МКТУ)
   * @type {number}
   * @memberof GetServerOptions200ResponseDataValues
   */
  MIN_SUGGEST_LENGTH?: number
}

/**
 * Check if a given object implements the GetServerOptions200ResponseDataValues interface.
 */
export function instanceOfGetServerOptions200ResponseDataValues(
  value: object
): value is GetServerOptions200ResponseDataValues {
  return true
}

export function GetServerOptions200ResponseDataValuesFromJSON(
  json: any
): GetServerOptions200ResponseDataValues {
  return GetServerOptions200ResponseDataValuesFromJSONTyped(json, false)
}

export function GetServerOptions200ResponseDataValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServerOptions200ResponseDataValues {
  if (json == null) {
    return json
  }
  return {
    PASSWORD_MIN_LENGTH:
      json['PASSWORD_MIN_LENGTH'] == null
        ? undefined
        : json['PASSWORD_MIN_LENGTH'],
    TRADE_MARK_IMAGE_MAX_SIZE:
      json['TRADE_MARK_IMAGE_MAX_SIZE'] == null
        ? undefined
        : json['TRADE_MARK_IMAGE_MAX_SIZE'],
    TRADE_MARK_IMAGE_MIME_TYPES:
      json['TRADE_MARK_IMAGE_MIME_TYPES'] == null
        ? undefined
        : json['TRADE_MARK_IMAGE_MIME_TYPES'],
    CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH:
      json['CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH'] == null
        ? undefined
        : json['CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH'],
    MIN_SUGGEST_LENGTH:
      json['MIN_SUGGEST_LENGTH'] == null
        ? undefined
        : json['MIN_SUGGEST_LENGTH'],
  }
}

export function GetServerOptions200ResponseDataValuesToJSON(
  value?: GetServerOptions200ResponseDataValues | null
): any {
  if (value == null) {
    return value
  }
  return {
    PASSWORD_MIN_LENGTH: value['PASSWORD_MIN_LENGTH'],
    TRADE_MARK_IMAGE_MAX_SIZE: value['TRADE_MARK_IMAGE_MAX_SIZE'],
    TRADE_MARK_IMAGE_MIME_TYPES: value['TRADE_MARK_IMAGE_MIME_TYPES'],
    CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH:
      value['CALL_TECH_SUPPORT_COMMENT_MIN_LENGTH'],
    MIN_SUGGEST_LENGTH: value['MIN_SUGGEST_LENGTH'],
  }
}
